<template>
  <v-row
    v-if="isOpen"
    no-gutters
    align-start
    justify-start
    fill-height
    class="sideBySideBody escalon-absolute-cover">
    <v-col cols="6">
      <side-by-side-main-image-view
        :largeViewSize="leftLargeViewSize"
        :largeViewFit="leftLargeViewFit"
        :transform="leftTransform"
        :imgOffset="leftImgOffset"
        :realLocation="realLocation"
        :isLeft="true"
        :context="sideBySideLeftContext"
        :syncContext="sideBySideRightContext"
        :isInBounds="isInBounds"
        @panBy="$emit('panBy', true, $event)"
        @updateZoom="$emit('updateZoom', true, $event)"
        @updateCenter="$emit('updateCenter', true, $event)"/>
    </v-col>
    <v-col cols="6">
      <side-by-side-main-image-view
        :largeViewSize="rightLargeViewSize"
        :largeViewFit="rightLargeViewFit"
        :transform="rightTransform"
        :imgOffset="rightImgOffset"
        :realLocation="realLocation"
        :isLeft="false"
        :context="sideBySideRightContext"
        :syncContext="sideBySideLeftContext"
        :isInBounds="isInBounds"
        @panBy="$emit('panBy', false, $event)"
        @updateZoom="$emit('updateZoom', false, $event)"
        @updateCenter="$emit('updateCenter', false, $event)"/>
    </v-col>
  </v-row>
</template>

<script>
import sideBySideMainImageView from "./SideBySideMainImageView";
import { mapGetters } from "vuex";

export default {
  name: "sideBySideBrowserBody",
  components: { sideBySideMainImageView },
  props: [
    "leftLargeViewSize",
    "leftLargeViewFit",
    "leftTransform",
    "leftImgOffset",
    "rightLargeViewSize",
    "rightLargeViewFit",
    "rightTransform",
    "rightImgOffset",
    "isInBounds",
    "realLocation"
  ],
  computed: {
    ...mapGetters([
      "sideBySideContext",
      "sideBySideLeftContext",
      "sideBySideRightContext"
    ]),
    isOpen() {
      return !!this.sideBySideContext;
    }
  }
};
</script>
